// const initalState = []
const initalState = null
const initalStateArray = []

const folderListReducer = (state = initalState, action) => {
	const {type, data} = action

	switch (type) {
		case "FETCH_FOLDER_LIST":
			return data
		
		default:
			return state
	}
}

const fileListReducer = (state = initalState, action) => {
	const {type, data} = action

	switch (type) {
		case "FETCH_FILE_LIST":
			return data

		case "CLEAR_FILE_LIST":
			return data
		
		default:
			return state
	}
}


const folderNavReducer = (state = initalState, action) => {
	const {type, data} = action

	switch (type) {
		case "FOLDER_NAV":
			return data
		
		default:
			return state
	}
}


const folderSelectReducer = (state = initalState, action) => {
	const {type, data} = action

	switch (type) {
		case "FOLDER_SELECT":
			return data

		case "FOLDER_DISSELECT":
			return data
		
		default:
			return state
	}
}


const propertySeqReducer = (state = initalState, action) => {
	const {type, data} = action

	switch (type) {
		case "FILE_SELECT":
			return data

		case "FILE_DISSELECT":
			return data
		
		default:
			return state
	}
}


const primaryPropertyFileSeqReducer = (state = initalState, action) => {
	const {type, data} = action

	switch (type) {
		case "PRIMARY_PROPERTY_FILE_SEQ":
			return data
		
		default:
			return state
	}
}


const propertyDetailReducer = (state = initalState, action) => {
	const {type, data} = action

	switch (type) {
		case "UPDATE_PROPERTY_DETAIL":
			return data

		case "REMOVE_PROPERTY_DETAIL":
			return data
		
		default:
			return state
	}
}


const propertyFileReducer = (state = initalState, action) => {
	const {type, data} = action

	switch (type) {
		case "PROPERTY_FILE_SELECT":
			return data

		case "PROPERTY_FILE_UNSELECT":
			return data
		
		default:
			return state
	}
}


const uploadFileSourceReducer = (state = initalState, action) => {
	const {type, data} = action

	switch (type) {
		case "UPLOAD_FILE_SOURCE_ADD":
			return data

		case "UPLOAD_FILE_SOURCE_REMOVE":
			return data
		
		default:
			return state
	}
}


// const uploadFileInfoReducer = (state = initalState, action) => {
// 	const {type, data} = action

// 	switch (type) {
// 		case "UPLOAD_FILE_INFO_ADD":
// 			return data

// 		case "UPLOAD_FILE_INFO_REMOVE":
// 			return data
		
// 		default:
// 			return state
// 	}
// }


const uploadFilePropertyReducer = (state = initalState, action) => {
	const {type, data} = action

	switch (type) {
		case "UPLOAD_FILE_PROPERTY_ADD":
			return data

		case "UPLOAD_FILE_PROPERTY_REMOVE":
			return data
		
		default:
			return state
	}
}


const advancedSearchReducer = (state = initalState, action) => {
	const {type, data} = action

	switch (type) {
		case "ADV_SEARCH_KEYWORD_ADD":
			return data

		case "ADV_SEARCH_KEYWORD_REMOVE":
			return data
		
		default:
			return state
	}
}


const companyListByFolderReducer = (state = initalState, action) => {
	const {type, data} = action

	switch (type) {
		case "COMPANY_LIST_BY_FOLDER":
			return data

		case "COMPANY_LIST_BY_FOLDER_REMOVE":
			return data
		
		default:
			return state
	}
}

const selectedFolderReducer = (state = initalState, action) => {
	const {type, data} = action

	switch (type) {
		case "SELECTED_FOLDER":
			return data

		case "SELECTED_FOLDER_REMOVE":
			return data
		
		default:
			return state
	}
}


export {
	folderListReducer, 
	fileListReducer, 
	folderNavReducer, 
	folderSelectReducer, 
	propertySeqReducer,
	primaryPropertyFileSeqReducer,
	propertyDetailReducer, 
	propertyFileReducer, 
	uploadFileSourceReducer, 
	// uploadFileInfoReducer, 
	uploadFilePropertyReducer,
	advancedSearchReducer,
	companyListByFolderReducer,
	selectedFolderReducer,
}